import { BaseService } from 'core/services';
import InsuranceRouteService from './InsuranceRouteService';

class InsuranceService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new InsuranceRouteService());
    }

    async invalidate(){
        const url = this.routeService.invalidate();
        const response = await this.apiClient.delete(url);
        return response.data || null;
    }

}

export default InsuranceService;